import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { generateListingDescriptionService } from "@/services/ai.service";
import { IAPIResponse } from "@/services/api.types";
import { AIListingFormData, AIListingResponse } from "@/types/ai.types";

export const usePostAiListingDescription = () => {
  return useMutation<IAPIResponse<AIListingResponse>, Error, AIListingFormData>({
    mutationFn: generateListingDescriptionService,
    retry: false,
    onError: err => toast.error(err.message),
  });
};
